import { patientNamespace } from "@/store/modules/patient";
import { userNamespace } from "@/store/modules/user";
import { User } from "@/store/modules/user/types";
import _ from "lodash";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {}
})
export default class AddPatient extends Vue {
  @Getter("user", userNamespace)
  user!: User;

  @Getter("vars", patientNamespace)
  vars!: any;

  get canAddNewPatientsFromCensus() {
    return !!_.get(this.vars, "uiConfig.elements.registerUrl", "");
  }

  get canAddPatients() {
    const isClinical = this.user.rights.includes("Clinical");
    return isClinical && this.canAddNewPatientsFromCensus;
  }
}
